module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.29131",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9650",
      "ably-hubspot-js": "static-2.4697",
      "atom": "static-1.5051",
      "conversations-async-data": "static-2.7643",
      "conversations-error-reporting": "static-1.8866",
      "conversations-internal-pub-sub": "static-1.15956",
      "conversations-internal-schema": "static-1.12859",
      "conversations-message-history": "static-1.12611",
      "conversations-test-sdk": "static-1.10483",
      "conversations-visitor-experience-components": "static-1.22494",
      "head-dlb": "static-1.4994",
      "hs-promise-utils": "static-1.5575",
      "hs-test-utils": "static-1.7994",
      "hubspot-dlb": "static-2.1845",
      "HubStyleTokens": "static-2.11448",
      "I18n": "static-7.1617",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.3001",
      "jasmine-runner": "static-1.6446",
      "quartz": "static-1.7000",
      "react-dlb": "static-1.78",
      "react-select-plus": "static-1.104",
      "react-transition-group": "static-2.64",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4457",
      "StyleGuideUI": "static-3.486",
      "transmute": "static-2.85",
      "urlinator": "static-1.4516",
      "usage-tracker": "static-1.7324",
      "usage-tracker-core": "static-1.7174",
      "usage-tracker-public": "static-1.7135",
      "viral-links-lib": "static-1.7038",
      "visitor-ui-component-library": "static-1.6119",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4792",
      "conversations-prop-types": "static-1.7431",
      "conversations-visitor-message-history": "static-1.21231",
      "cssUtils": "static-1.786",
      "enviro": "static-4.446",
      "flux-actions": "static-1.333",
      "foundations-components": "static-1.7892",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6202",
      "hubspot-url-utils": "static-1.4115",
      "immutable": "static-2.79",
      "metrics-js": "static-1.9619",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.397",
      "raven": "static-3.5907",
      "react": "static-7.185",
      "react-aria": "static-1.65",
      "react-dom": "static-7.85",
      "react-redux": "static-7.71",
      "react-rhumb": "static-1.16647",
      "react-utils": "static-2.5326",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8122",
      "signup-constants": "static-1.18803",
      "styled-components": "static-2.89",
      "usage-tracker-multi": "static-1.5738",
      "visitor-ui-component-library-icons": "static-1.5930",
      "hs-promise-rejection-tracking": "static-1.5566",
      "raven-hubspot": "static-1.6214",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3385",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.85",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.81",
      "quartz-config": "static-1.778",
      "quartz-core": "static-1.6219",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4844",
      "foundations-theming": "static-1.4398",
      "UIComponents": "static-3.8394",
      "customer-data-email": "static-1.17993",
      "cv-backend-services": "static-1.1552",
      "immutable-less": "static-1.4635",
      "conversations-skeleton-state": "static-1.7227",
      "crm-events-viz-core": "static-1.33116",
      "customer-data-objects": "static-1.7643",
      "icons": "static-2.644",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4631",
      "ui-images": "static-2.1147",
      "HeadJS": "static-2.754",
      "framer-motion": "static-1.71",
      "hs-test-utils-bend-plugin": "static-1.3105",
      "msw": "static-1.39",
      "testing-library": "static-1.151",
      "i18n-data": "static-1.220",
      "moment-timezone": "static-5.82",
      "jasmine": "static-4.4307",
      "signup-ui-url-generator": "static-2.8024",
      "HubStyle": "static-2.11755",
      "quartz-i18n": "static-1.675",
      "sassPrefix": "static-1.155",
      "bend-plugin-foundations-components": "static-1.4161",
      "floating-ui": "static-1.55",
      "foundations-theming-specialty": "static-1.2114",
      "hs-story-utils": "static-1.9407",
      "react-create-root-preference": "static-1.15",
      "react-virtualized": "static-2.98",
      "tanstack-table": "static-1.54",
      "trellis-assets": "static-1.1812",
      "ui-fonts": "static-1.710",
      "hs-locale-management": "static-1.67",
      "csstype": "static-1.50",
      "quartz-head": "static-1.665",
      "quick-fetch": "static-1.3898",
      "web-vitals": "static-1.4",
      "quartz-routing": "static-1.430",
      "usage-tracker-anonymous": "static-1.5741",
      "bender-build-tools": "static-1.3171",
      "dispatcher": "static-1.136",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.830",
      "hubspotter-http": "static-1.4635",
      "mobile-manifest-mixins": "static-1.529",
      "module-federation": "static-1.22",
      "quartz-auth": "static-1.675",
      "quartz-test": "static-1.675",
      "quartz-tracking": "static-1.379",
      "usage-tracker-container": "static-1.7314",
      "bend-plugin-foundations-theming": "static-1.2881",
      "foundations-theming-base": "static-1.3383",
      "stylex": "static-1.32",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4630",
      "customer-data-ui-utilities": "static-1.9806",
      "FileManagerCore": "static-1.39053",
      "FileManagerLib": "static-1.39194",
      "hubspot-apollo-client": "static-1.4857",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.524",
      "timezone-utils": "static-2.5224",
      "ui-gdpr-components": "static-1.10326",
      "ts-schema": "static-1.4063",
      "ai-components-ui-library": "static-1.8878",
      "avatar-components": "static-1.2477",
      "content-assistance-lib": "static-1.7717",
      "crm-component-utils": "static-1.39011",
      "crm-display-components": "static-1.24761",
      "crm-fe-perf": "static-1.22883",
      "crm-links": "static-1.6265",
      "crm-message-bus": "static-1.42927",
      "crm-search-service-types": "static-1.1132",
      "crm-source-interpretation-lib": "static-1.5321",
      "customer-data-communicator": "static-1.45475",
      "customer-data-filters-ui": "static-1.39675",
      "customer-data-objects-ui-components": "static-1.13004",
      "customer-data-properties": "static-1.51459",
      "customer-data-rte": "static-1.32932",
      "draft-plugins": "static-2.21633",
      "file-manager-components": "static-1.23554",
      "framework-data-schema-resolvers": "static-1.6862",
      "frontend-preferences-client": "static-1.7908",
      "hubspot-prosemirror": "static-1.18178",
      "object-comments-thread-lib": "static-1.10587",
      "prosemirror-user-and-team-at-mentions": "static-1.536",
      "reference-resolvers-lite": "static-1.8074",
      "ui-addon-upgrades": "static-9.17954",
      "universal-associations-select": "static-1.11008",
      "universal-record-utils-lib": "static-1.820",
      "wootric-nps": "static-1.6961",
      "inbound-db-properties-service-client": "static-1.3829",
      "property-translator": "static-1.5380",
      "bend-plugin-chirp-manifest": "static-1.41",
      "chirp-fetch": "static-1.1867",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "hub-http-shared-msw-handlers": "static-1.9907",
      "hubspotter-http-shared-msw-handlers": "static-1.9905",
      "usage-tracker-session-replay": "static-1.5010",
      "react-dnd-compat": "static-1.4599",
      "audio-components": "static-1.5882",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29253",
      "FileManagerImages": "static-1.36705",
      "foundations-components-legacy": "static-1.917",
      "immerable": "static-1.4133",
      "ui-universal-auth": "static-1.8953",
      "video-components": "static-1.13194",
      "video-data-lib": "static-1.34849",
      "video-embed": "static-1.35683",
      "hubspot-apollo-cache": "static-1.316",
      "chatspot-core": "static-1.21176",
      "ContentUtils": "static-1.68291",
      "copilot-toolkit": "static-1.11075",
      "superstore": "static-1.4743",
      "ui-addon-video-player": "static-1.8683",
      "ui-coaching-tips": "static-1.28484",
      "card-properties-lib": "static-1.44106",
      "commerce-subscription-lib": "static-1.37039",
      "crm-actions": "static-1.6302",
      "crm-cards-sdk": "static-1.43511",
      "customer-data-properties-shared-msw-handlers": "static-1.9234",
      "customer-data-property-utils": "static-1.8067",
      "customer-data-tracking": "static-1.6868",
      "hs-resources": "static-1.133",
      "inbound-db-meta-service-client": "static-1.3572",
      "pulse": "static-1.552",
      "framework-data-table": "static-2.11857",
      "location-customization-utils-lib": "static-1.9179",
      "calling-error-reporting": "static-1.31288",
      "calling-internal-common": "static-1.31281",
      "calling-usage-tracker": "static-1.6522",
      "crm_data": "static-4.91888",
      "customer-data-content": "static-1.27235",
      "draft-content-plugins": "static-1.28202",
      "draft-convert": "static-2.72",
      "draft-extend": "static-3.74",
      "draft-js": "static-5.77",
      "draft-signature-plugin": "static-1.24005",
      "EmailSignatureEditor": "static-1.24317",
      "hubspot-prosemirror-plugins": "static-1.18170",
      "integration-settings-components": "static-1.15392",
      "integrations-lib": "static-1.16037",
      "integrations-tracking-lib": "static-1.5579",
      "native-integrations-shared-strings": "static-1.7762",
      "nav-meta": "static-1.29602",
      "onboarding-scopes": "static-1.6441",
      "outreach-assistant-email-generation": "static-1.6159",
      "prosemirror-copilot": "static-1.11563",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.38022",
      "react-colorpicker": "static-2.10190",
      "reference-resolvers": "static-1.8149",
      "rich-text-lib": "static-1.19789",
      "sales-email-signature-service-client": "static-1.3822",
      "sequences-lib": "static-1.8000",
      "ui-addon-i18n": "static-1.11131",
      "ui-addon-iframeable": "static-1.9036",
      "ui-business-units-lib": "static-1.9029",
      "ui-shepherd-react": "static-3.10137",
      "user-context": "static-1.5082",
      "whatsapp-sending-lib": "static-1.5620",
      "events-data-lib": "static-1.195",
      "customer-data-filters-ui-msw-helpers": "static-1.22110",
      "customer-data-reference-ui-components": "static-1.13140",
      "FormUrlGenerator": "static-2.4698",
      "framework-builder-read-service-client": "static-1.3991",
      "framework-data-schema-quick-fetch": "static-1.6767",
      "multi-account-reference-resolvers": "static-1.957",
      "onboarding-tours": "static-1.16555",
      "reporting-datasets-permissions-lib": "static-1.13614",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21515",
      "calling-global-api": "static-1.64432",
      "calling-lifecycle-internal": "static-1.65814",
      "calling-lifecycle-messages": "static-1.58108",
      "commerce-products-lib": "static-1.9470",
      "conditional-properties-service-client": "static-1.3779",
      "external-options-client-types": "static-1.4140",
      "google-libphonenumber": "static-1.37",
      "inbounddb-objects-service-types": "static-1.4205",
      "meetings-icalendar-utils-lib": "static-1.611",
      "multi-currency-client-types": "static-1.3674",
      "object-builder-ui-client": "static-1.48655",
      "pipeline-validation-client-types": "static-1.3948",
      "property-value-citations": "static-1.2073",
      "smart-property-lib": "static-1.6815",
      "tiered-pricing": "static-1.1150",
      "ui-addon-form-validation": "static-1.10972",
      "video-components-external": "static-1.11191",
      "batch-promise": "static-1.1520",
      "crm-pipelines-api-client-types": "static-1.4124",
      "persist-promise": "static-1.3677",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25305",
      "knowledge-content-types": "static-1.8483",
      "payment-link-components": "static-1.23468",
      "ui-addon-emoji-picker": "static-1.9868",
      "call-summary": "static-1.39122",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10053",
      "laboratory-lib": "static-3.7138",
      "merchandise-lib": "static-1.263",
      "purchase-motions-components": "static-1.5847",
      "crm-object-search-query-utilities": "static-1.9522",
      "amplitude-session-replay-browser": "static-1.59",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.749",
      "content-icons-ui": "static-1.2220",
      "social-insights-client-types": "static-1.22018",
      "outpost": "static-1.4165",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4791",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5539",
      "magpie-types": "static-1.4999",
      "simple-logging-lib": "static-1.3028",
      "growth-onboarding-feedback-components": "static-1.6561",
      "customer-data-sidebar": "static-2.45947",
      "enrichment-properties-lib": "static-1.15933",
      "commerce-billing-lib": "static-1.18998",
      "commerce-shared-components-lib": "static-1.18468",
      "commerce-tools-ui-lib": "static-1.10310",
      "bend-plugin-pulse": "static-1.55",
      "directed-graph": "static-1.914",
      "event-emitter": "static-1.928",
      "fast-json-patch": "static-1.62",
      "customer-data-associations": "static-1.7304",
      "deal-intel-decorators": "static-1.1911",
      "reporting-data": "static-1.67444",
      "tanstack-virtual": "static-1.29",
      "ui-addon-draggable": "static-3.4747",
      "crm-record-cards-service-types": "static-1.3587",
      "self-service-api": "static-1.10228",
      "crm_universal": "static-1.21966",
      "SalesContentIndexUI": "static-3.9210",
      "content-embed-lib": "static-1.7320",
      "data-model-builder-lib": "static-1.12257",
      "remote-ui": "static-1.64",
      "ui-components-test-utils": "static-1.5585",
      "ui-extensions-remote-renderer": "static-1.16936",
      "universal-page-editor-lib": "static-1.2993",
      "integrations-error-boundary-lib": "static-1.13452",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10349",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.467",
      "messaging-types-lib": "static-1.45938",
      "ai-addon-copilot-preview": "static-1.8090",
      "copilot-plugins": "static-1.11048",
      "data-token-picker": "static-1.16367",
      "sequences-client-types-lib": "static-1.7857",
      "foundations-components-test-utils": "static-1.5375",
      "navigation-messaging": "static-1.7292",
      "getting-started-shared-tasks": "static-1.18437",
      "getting-started-shared-tasks-store": "static-1.17555",
      "onboarding-tours-utils": "static-1.621",
      "messaging-usage-based-billing-components-lib": "static-1.1063",
      "whatsapp-management-lib": "static-1.8779",
      "growth-data-modal": "static-1.5394",
      "growth-onboarding-confetti": "static-1.3046",
      "growth-onboarding-next-action-utils": "static-1.1853",
      "navigation-components": "static-1.17965",
      "onboarding-tours-client": "static-1.4769",
      "ui-shepherd-tracker": "static-1.7518",
      "shared-worker-versioning": "static-1.11017",
      "voice-sms-access-library": "static-1.894",
      "commerce-permissions": "static-1.747",
      "products-iframe-lib": "static-1.7867",
      "products-ui-components-shared-msw-handlers": "static-1.10289",
      "data-agent-kit": "static-1.159",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9990",
      "fsm": "static-1.3712",
      "policy-lib": "static-1.6758",
      "react-tinymce": "static-1.55175",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54301",
      "tinymce-plugins": "static-1.57415",
      "tinymce-themes": "static-1.56271",
      "content-media-composition-data-lib": "static-1.12178",
      "content-media-compositions": "static-2.16185",
      "idb-keyval": "static-1.43",
      "media-bridge-lib": "static-1.18885",
      "ui-addon-opt": "static-4.8351",
      "commerce-tours-lib": "static-1.6051",
      "growth-onboarding-reliability": "static-1.5063",
      "sales-checkout-service-client": "static-1.3619",
      "calling-cross-tab-library": "static-1.19265",
      "calling-lifecycle-usage-tracker": "static-1.8638",
      "purchase-motions-api": "static-1.5850",
      "trials-service-types": "static-1.3882",
      "reactive-lib": "static-1.702",
      "card-payment-highlight-lib": "static-1.37104",
      "card-subscription-highlight-lib": "static-1.39462",
      "commerce-contract-lib": "static-1.11949",
      "invoices-highlight-card-lib": "static-1.54648",
      "orders-highlight-card-lib": "static-1.21405",
      "products-highlight-card-lib": "static-1.17753",
      "quotes-highlight-card-lib": "static-1.71932",
      "usage-based-billing-components-lib": "static-1.8774",
      "utility-belt": "static-1.2516",
      "payments-enrollment-embed-lib": "static-1.22730",
      "stripe-embedded-components": "static-1.7462",
      "growth-onboarding-empty-states": "static-1.5676",
      "InboxConnectUtils": "static-4.14749",
      "payments-post-enroll-local-storage-lib": "static-1.5088",
      "qrcode-generator": "static-1.68",
      "deal-intel-utils": "static-1.1915",
      "storybook-react": "static-1.32",
      "reporting-client-types": "static-1.2496",
      "react-flip-move": "static-1.69",
      "FireAlarmUi": "static-1.4496",
      "sales-templates-service-types-lib": "static-1.4153",
      "ui-asset-management-lib": "static-1.10995",
      "association-settings-lib": "static-1.10213",
      "collaboration-sidebar": "static-1.57727",
      "conditional-property-settings-modal": "static-1.12398",
      "data-model-commons-lib": "static-1.12527",
      "final-form": "static-1.69",
      "html-to-image": "static-1.53",
      "nudge-client-utils": "static-1.2519",
      "object-definition-builder-lib": "static-1.7074",
      "property-management-iframe": "static-1.13064",
      "property-usages-lib": "static-1.5417",
      "reactflow": "static-1.63",
      "simple-data-table": "static-1.2710",
      "used-in-list-lib": "static-1.6929",
      "visual-association": "static-1.5857",
      "highcharts": "static-8.103",
      "reporting-visualizations": "static-1.59520",
      "ui-extensibility-client-types": "static-1.3910",
      "google-sheets-integration-lib": "static-1.166",
      "microsoft-drive-integration-lib": "static-1.282",
      "automation-platform-service-types": "static-1.2580",
      "ContentData": "static-1.68366",
      "email-portal-health-service-types": "static-1.955",
      "marketing-email-service-types": "static-1.1902",
      "ai-rendering-library": "static-1.10057",
      "ai-settings-ui-library": "static-1.7850",
      "breeze-engine-lib": "static-1.548",
      "ui-brand-identity-lib": "static-1.15179",
      "messaging-shared-utils-lib": "static-1.512",
      "messaging-user-info-utils-lib": "static-1.682",
      "content-whatsapp-service-types": "static-1.379",
      "marketing-platform-lib": "static-1.6833",
      "short-messages-app-service-client": "static-1.3949",
      "ui-tool-access": "static-1.10130",
      "onboarding-data-sync-lib": "static-1.1922",
      "growth-onboarding-next-action-components": "static-1.1881",
      "user-context-client": "static-1.4592",
      "nest": "static-1.205",
      "calling-orchestration-schema": "static-1.35671",
      "sales-views-client-types": "static-1.4244",
      "trellis-story-utils": "static-1.4495",
      "hub-http-contrib": "static-1.3022",
      "interframe": "static-3.4740",
      "tinymce-data": "static-1.40386",
      "ui-addon-sales-email": "static-1.5191",
      "codemirror": "static-5.94",
      "layout-dnd-components": "static-1.12403",
      "layout-dnd-utils": "static-1.11378",
      "react-codemirror": "static-1.10605",
      "NamespacedHubStyle": "static-2.9041",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.39988",
      "zustand": "static-1.74",
      "accounting-integrations-ui-components": "static-1.7027",
      "invoices-ui-lib": "static-1.54664",
      "commerce-products-api": "static-1.2253",
      "invoices-iframe-lib": "static-1.56722",
      "quotes-modal-lib": "static-1.102610",
      "quotes-ui-lib": "static-1.80653",
      "platform-infra-nav-components": "static-1.7655",
      "reporting-ui-components": "static-2.64715",
      "subscription-experience-data-types": "static-1.14902",
      "marketplace-ui-apps-core": "static-1.18168",
      "stripe-connect-js": "static-1.68",
      "ui-addon-react-router-dom": "static-1.9524",
      "nested-table": "static-1.206",
      "chatspot-widget-iframe": "static-1.21167",
      "collaboration-sidebar-common": "static-1.2524",
      "crm-properties-common-lib": "static-1.5861",
      "ui-addon-draggable-compat": "static-2.4235",
      "nudge-custom-function-registry": "static-1.2276",
      "nudge-renderer-utils": "static-1.2595",
      "whisper-core-api": "static-1.6552",
      "property-management-common": "static-1.5352",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15095",
      "advanced-menus-lib": "static-1.12039",
      "ExportDialog": "static-6.10371",
      "ui-memberships-settings-lib": "static-1.33981",
      "embedded-academy-lib": "static-1.14262",
      "highlight.js": "static-1.78",
      "reporting-action-components": "static-1.41239",
      "reporting-snowflake": "static-1.56062",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9703",
      "browser-eslint": "static-2.57",
      "commerce-tax-lib": "static-1.505",
      "price-books-api": "static-1.586",
      "price-books-components": "static-1.644",
      "property-description-translator": "static-1.3825",
      "ramp-editor": "static-1.84",
      "commerce-analytics-service-client": "static-1.3607",
      "totals-ui-components": "static-1.23529",
      "reporting-plugins": "static-1.10287",
      "reporting-reports": "static-1.67122",
      "edison-service-client-types": "static-1.366",
      "developer-experience-shared-components": "static-1.10489",
      "marketplace-ui-client-types": "static-1.17042",
      "marketplace-ui-common": "static-1.19635",
      "ui-addon-integrations-directory-panel": "static-2.7976",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.153",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15094",
      "simple-menus-lib": "static-1.16611",
      "academy-common-lib": "static-1.13722",
      "dashboard-lib": "static-1.81428",
      "share-with-third-party-component-lib": "static-1.8683",
      "line-items-api": "static-1.655",
      "commerce-totals-service-types": "static-1.3800",
      "campaign-roi-lib": "static-1.9017",
      "apps-service-types": "static-1.3856",
      "oauth-service-types": "static-1.4229",
      "academy-service-client": "static-1.3662",
      "croppie": "static-2.10",
      "trellis-ecosystem": "static-1.7091",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.29131",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9650",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4697",
      "atom": "/atom/static-1.5051",
      "conversations-async-data": "/conversations-async-data/static-2.7643",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8866",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15956",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12859",
      "conversations-message-history": "/conversations-message-history/static-1.12611",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10483",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22494",
      "head-dlb": "/head-dlb/static-1.4994",
      "hs-promise-utils": "/hs-promise-utils/static-1.5575",
      "hs-test-utils": "/hs-test-utils/static-1.7994",
      "hubspot-dlb": "/hubspot-dlb/static-2.1845",
      "HubStyleTokens": "/HubStyleTokens/static-2.11448",
      "I18n": "/I18n/static-7.1617",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.3001",
      "jasmine-runner": "/jasmine-runner/static-1.6446",
      "quartz": "/quartz/static-1.7000",
      "react-dlb": "/react-dlb/static-1.78",
      "react-select-plus": "/react-select-plus/static-1.104",
      "react-transition-group": "/react-transition-group/static-2.64",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4457",
      "StyleGuideUI": "/StyleGuideUI/static-3.486",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4516",
      "usage-tracker": "/usage-tracker/static-1.7324",
      "usage-tracker-core": "/usage-tracker-core/static-1.7174",
      "usage-tracker-public": "/usage-tracker-public/static-1.7135",
      "viral-links-lib": "/viral-links-lib/static-1.7038",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6119",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4792",
      "conversations-prop-types": "/conversations-prop-types/static-1.7431",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.21231",
      "cssUtils": "/cssUtils/static-1.786",
      "enviro": "/enviro/static-4.446",
      "flux-actions": "/flux-actions/static-1.333",
      "foundations-components": "/foundations-components/static-1.7892",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6202",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
      "immutable": "/immutable/static-2.79",
      "metrics-js": "/metrics-js/static-1.9619",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.397",
      "raven": "/raven/static-3.5907",
      "react": "/react/static-7.185",
      "react-aria": "/react-aria/static-1.65",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.71",
      "react-rhumb": "/react-rhumb/static-1.16647",
      "react-utils": "/react-utils/static-2.5326",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8122",
      "signup-constants": "/signup-constants/static-1.18803",
      "styled-components": "/styled-components/static-2.89",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5738",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5930",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
      "raven-hubspot": "/raven-hubspot/static-1.6214",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3385",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.81",
      "quartz-config": "/quartz-config/static-1.778",
      "quartz-core": "/quartz-core/static-1.6219",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4844",
      "foundations-theming": "/foundations-theming/static-1.4398",
      "UIComponents": "/UIComponents/static-3.8394",
      "customer-data-email": "/customer-data-email/static-1.17993",
      "cv-backend-services": "/cv-backend-services/static-1.1552",
      "immutable-less": "/immutable-less/static-1.4635",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7227",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33116",
      "customer-data-objects": "/customer-data-objects/static-1.7643",
      "icons": "/icons/static-2.644",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4631",
      "ui-images": "/ui-images/static-2.1147",
      "HeadJS": "/HeadJS/static-2.754",
      "framer-motion": "/framer-motion/static-1.71",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3105",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.151",
      "i18n-data": "/i18n-data/static-1.220",
      "moment-timezone": "/moment-timezone/static-5.82",
      "jasmine": "/jasmine/static-4.4307",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8024",
      "HubStyle": "/HubStyle/static-2.11755",
      "quartz-i18n": "/quartz-i18n/static-1.675",
      "sassPrefix": "/sassPrefix/static-1.155",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4161",
      "floating-ui": "/floating-ui/static-1.55",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2114",
      "hs-story-utils": "/hs-story-utils/static-1.9407",
      "react-create-root-preference": "/react-create-root-preference/static-1.15",
      "react-virtualized": "/react-virtualized/static-2.98",
      "tanstack-table": "/tanstack-table/static-1.54",
      "trellis-assets": "/trellis-assets/static-1.1812",
      "ui-fonts": "/ui-fonts/static-1.710",
      "hs-locale-management": "/hs-locale-management/static-1.67",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.665",
      "quick-fetch": "/quick-fetch/static-1.3898",
      "web-vitals": "/web-vitals/static-1.4",
      "quartz-routing": "/quartz-routing/static-1.430",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5741",
      "bender-build-tools": "/bender-build-tools/static-1.3171",
      "dispatcher": "/dispatcher/static-1.136",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.830",
      "hubspotter-http": "/hubspotter-http/static-1.4635",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.529",
      "module-federation": "/module-federation/static-1.22",
      "quartz-auth": "/quartz-auth/static-1.675",
      "quartz-test": "/quartz-test/static-1.675",
      "quartz-tracking": "/quartz-tracking/static-1.379",
      "usage-tracker-container": "/usage-tracker-container/static-1.7314",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2881",
      "foundations-theming-base": "/foundations-theming-base/static-1.3383",
      "stylex": "/stylex/static-1.32",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4630",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9806",
      "FileManagerCore": "/FileManagerCore/static-1.39053",
      "FileManagerLib": "/FileManagerLib/static-1.39194",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4857",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.524",
      "timezone-utils": "/timezone-utils/static-2.5224",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10326",
      "ts-schema": "/ts-schema/static-1.4063",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8878",
      "avatar-components": "/avatar-components/static-1.2477",
      "content-assistance-lib": "/content-assistance-lib/static-1.7717",
      "crm-component-utils": "/crm-component-utils/static-1.39011",
      "crm-display-components": "/crm-display-components/static-1.24761",
      "crm-fe-perf": "/crm-fe-perf/static-1.22883",
      "crm-links": "/crm-links/static-1.6265",
      "crm-message-bus": "/crm-message-bus/static-1.42927",
      "crm-search-service-types": "/crm-search-service-types/static-1.1132",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5321",
      "customer-data-communicator": "/customer-data-communicator/static-1.45475",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39675",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13004",
      "customer-data-properties": "/customer-data-properties/static-1.51459",
      "customer-data-rte": "/customer-data-rte/static-1.32932",
      "draft-plugins": "/draft-plugins/static-2.21633",
      "file-manager-components": "/file-manager-components/static-1.23554",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6862",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7908",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18178",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10587",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.536",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8074",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17954",
      "universal-associations-select": "/universal-associations-select/static-1.11008",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.820",
      "wootric-nps": "/wootric-nps/static-1.6961",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3829",
      "property-translator": "/property-translator/static-1.5380",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.41",
      "chirp-fetch": "/chirp-fetch/static-1.1867",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9907",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9905",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5010",
      "react-dnd-compat": "/react-dnd-compat/static-1.4599",
      "audio-components": "/audio-components/static-1.5882",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29253",
      "FileManagerImages": "/FileManagerImages/static-1.36705",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.917",
      "immerable": "/immerable/static-1.4133",
      "ui-universal-auth": "/ui-universal-auth/static-1.8953",
      "video-components": "/video-components/static-1.13194",
      "video-data-lib": "/video-data-lib/static-1.34849",
      "video-embed": "/video-embed/static-1.35683",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.316",
      "chatspot-core": "/chatspot-core/static-1.21176",
      "ContentUtils": "/ContentUtils/static-1.68291",
      "copilot-toolkit": "/copilot-toolkit/static-1.11075",
      "superstore": "/superstore/static-1.4743",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8683",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28484",
      "card-properties-lib": "/card-properties-lib/static-1.44106",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37039",
      "crm-actions": "/crm-actions/static-1.6302",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43511",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9234",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8067",
      "customer-data-tracking": "/customer-data-tracking/static-1.6868",
      "hs-resources": "/hs-resources/static-1.133",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3572",
      "pulse": "/pulse/static-1.552",
      "framework-data-table": "/framework-data-table/static-2.11857",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9179",
      "calling-error-reporting": "/calling-error-reporting/static-1.31288",
      "calling-internal-common": "/calling-internal-common/static-1.31281",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6522",
      "crm_data": "/crm_data/static-4.91888",
      "customer-data-content": "/customer-data-content/static-1.27235",
      "draft-content-plugins": "/draft-content-plugins/static-1.28202",
      "draft-convert": "/draft-convert/static-2.72",
      "draft-extend": "/draft-extend/static-3.74",
      "draft-js": "/draft-js/static-5.77",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24005",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24317",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18170",
      "integration-settings-components": "/integration-settings-components/static-1.15392",
      "integrations-lib": "/integrations-lib/static-1.16037",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5579",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7762",
      "nav-meta": "/nav-meta/static-1.29602",
      "onboarding-scopes": "/onboarding-scopes/static-1.6441",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6159",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.11563",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.38022",
      "react-colorpicker": "/react-colorpicker/static-2.10190",
      "reference-resolvers": "/reference-resolvers/static-1.8149",
      "rich-text-lib": "/rich-text-lib/static-1.19789",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3822",
      "sequences-lib": "/sequences-lib/static-1.8000",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11131",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9036",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9029",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10137",
      "user-context": "/user-context/static-1.5082",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5620",
      "events-data-lib": "/events-data-lib/static-1.195",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22110",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13140",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4698",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3991",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6767",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.957",
      "onboarding-tours": "/onboarding-tours/static-1.16555",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13614",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21515",
      "calling-global-api": "/calling-global-api/static-1.64432",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65814",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58108",
      "commerce-products-lib": "/commerce-products-lib/static-1.9470",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3779",
      "external-options-client-types": "/external-options-client-types/static-1.4140",
      "google-libphonenumber": "/google-libphonenumber/static-1.37",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4205",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.611",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3674",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48655",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3948",
      "property-value-citations": "/property-value-citations/static-1.2073",
      "smart-property-lib": "/smart-property-lib/static-1.6815",
      "tiered-pricing": "/tiered-pricing/static-1.1150",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10972",
      "video-components-external": "/video-components-external/static-1.11191",
      "batch-promise": "/batch-promise/static-1.1520",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4124",
      "persist-promise": "/persist-promise/static-1.3677",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25305",
      "knowledge-content-types": "/knowledge-content-types/static-1.8483",
      "payment-link-components": "/payment-link-components/static-1.23468",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9868",
      "call-summary": "/call-summary/static-1.39122",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10053",
      "laboratory-lib": "/laboratory-lib/static-3.7138",
      "merchandise-lib": "/merchandise-lib/static-1.263",
      "purchase-motions-components": "/purchase-motions-components/static-1.5847",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9522",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.749",
      "content-icons-ui": "/content-icons-ui/static-1.2220",
      "social-insights-client-types": "/social-insights-client-types/static-1.22018",
      "outpost": "/outpost/static-1.4165",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4791",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5539",
      "magpie-types": "/magpie-types/static-1.4999",
      "simple-logging-lib": "/simple-logging-lib/static-1.3028",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6561",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45947",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15933",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18998",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18468",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10310",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.55",
      "directed-graph": "/directed-graph/static-1.914",
      "event-emitter": "/event-emitter/static-1.928",
      "fast-json-patch": "/fast-json-patch/static-1.62",
      "customer-data-associations": "/customer-data-associations/static-1.7304",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1911",
      "reporting-data": "/reporting-data/static-1.67444",
      "tanstack-virtual": "/tanstack-virtual/static-1.29",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4747",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
      "self-service-api": "/self-service-api/static-1.10228",
      "crm_universal": "/crm_universal/static-1.21966",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9210",
      "content-embed-lib": "/content-embed-lib/static-1.7320",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12257",
      "remote-ui": "/remote-ui/static-1.64",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5585",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16936",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2993",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13452",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10349",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.467",
      "messaging-types-lib": "/messaging-types-lib/static-1.45938",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8090",
      "copilot-plugins": "/copilot-plugins/static-1.11048",
      "data-token-picker": "/data-token-picker/static-1.16367",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7857",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5375",
      "navigation-messaging": "/navigation-messaging/static-1.7292",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18437",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17555",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.621",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1063",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8779",
      "growth-data-modal": "/growth-data-modal/static-1.5394",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3046",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1853",
      "navigation-components": "/navigation-components/static-1.17965",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4769",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7518",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11017",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.894",
      "commerce-permissions": "/commerce-permissions/static-1.747",
      "products-iframe-lib": "/products-iframe-lib/static-1.7867",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10289",
      "data-agent-kit": "/data-agent-kit/static-1.159",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9990",
      "fsm": "/fsm/static-1.3712",
      "policy-lib": "/policy-lib/static-1.6758",
      "react-tinymce": "/react-tinymce/static-1.55175",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54301",
      "tinymce-plugins": "/tinymce-plugins/static-1.57415",
      "tinymce-themes": "/tinymce-themes/static-1.56271",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12178",
      "content-media-compositions": "/content-media-compositions/static-2.16185",
      "idb-keyval": "/idb-keyval/static-1.43",
      "media-bridge-lib": "/media-bridge-lib/static-1.18885",
      "ui-addon-opt": "/ui-addon-opt/static-4.8351",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6051",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5063",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3619",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19265",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8638",
      "purchase-motions-api": "/purchase-motions-api/static-1.5850",
      "trials-service-types": "/trials-service-types/static-1.3882",
      "reactive-lib": "/reactive-lib/static-1.702",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37104",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39462",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11949",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54648",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21405",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17753",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71932",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8774",
      "utility-belt": "/utility-belt/static-1.2516",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22730",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7462",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5676",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14749",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5088",
      "qrcode-generator": "/qrcode-generator/static-1.68",
      "deal-intel-utils": "/deal-intel-utils/static-1.1915",
      "storybook-react": "/storybook-react/static-1.32",
      "reporting-client-types": "/reporting-client-types/static-1.2496",
      "react-flip-move": "/react-flip-move/static-1.69",
      "FireAlarmUi": "/FireAlarmUi/static-1.4496",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4153",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10995",
      "association-settings-lib": "/association-settings-lib/static-1.10213",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57727",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12398",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12527",
      "final-form": "/final-form/static-1.69",
      "html-to-image": "/html-to-image/static-1.53",
      "nudge-client-utils": "/nudge-client-utils/static-1.2519",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7074",
      "property-management-iframe": "/property-management-iframe/static-1.13064",
      "property-usages-lib": "/property-usages-lib/static-1.5417",
      "reactflow": "/reactflow/static-1.63",
      "simple-data-table": "/simple-data-table/static-1.2710",
      "used-in-list-lib": "/used-in-list-lib/static-1.6929",
      "visual-association": "/visual-association/static-1.5857",
      "highcharts": "/highcharts/static-8.103",
      "reporting-visualizations": "/reporting-visualizations/static-1.59520",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3910",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.166",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.282",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2580",
      "ContentData": "/ContentData/static-1.68366",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.955",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1902",
      "ai-rendering-library": "/ai-rendering-library/static-1.10057",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7850",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.548",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15179",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.512",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.682",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.379",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6833",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3949",
      "ui-tool-access": "/ui-tool-access/static-1.10130",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1922",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1881",
      "user-context-client": "/user-context-client/static-1.4592",
      "nest": "/nest/static-1.205",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35671",
      "sales-views-client-types": "/sales-views-client-types/static-1.4244",
      "trellis-story-utils": "/trellis-story-utils/static-1.4495",
      "hub-http-contrib": "/hub-http-contrib/static-1.3022",
      "interframe": "/interframe/static-3.4740",
      "tinymce-data": "/tinymce-data/static-1.40386",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5191",
      "codemirror": "/codemirror/static-5.94",
      "layout-dnd-components": "/layout-dnd-components/static-1.12403",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11378",
      "react-codemirror": "/react-codemirror/static-1.10605",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9041",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.39988",
      "zustand": "/zustand/static-1.74",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7027",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54664",
      "commerce-products-api": "/commerce-products-api/static-1.2253",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56722",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102610",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80653",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7655",
      "reporting-ui-components": "/reporting-ui-components/static-2.64715",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14902",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18168",
      "stripe-connect-js": "/stripe-connect-js/static-1.68",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9524",
      "nested-table": "/nested-table/static-1.206",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21167",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2524",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5861",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4235",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2276",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2595",
      "whisper-core-api": "/whisper-core-api/static-1.6552",
      "property-management-common": "/property-management-common/static-1.5352",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15095",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12039",
      "ExportDialog": "/ExportDialog/static-6.10371",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33981",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14262",
      "highlight.js": "/highlight.js/static-1.78",
      "reporting-action-components": "/reporting-action-components/static-1.41239",
      "reporting-snowflake": "/reporting-snowflake/static-1.56062",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9703",
      "browser-eslint": "/browser-eslint/static-2.57",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.505",
      "price-books-api": "/price-books-api/static-1.586",
      "price-books-components": "/price-books-components/static-1.644",
      "property-description-translator": "/property-description-translator/static-1.3825",
      "ramp-editor": "/ramp-editor/static-1.84",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3607",
      "totals-ui-components": "/totals-ui-components/static-1.23529",
      "reporting-plugins": "/reporting-plugins/static-1.10287",
      "reporting-reports": "/reporting-reports/static-1.67122",
      "edison-service-client-types": "/edison-service-client-types/static-1.366",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10489",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17042",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19635",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7976",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.153",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15094",
      "simple-menus-lib": "/simple-menus-lib/static-1.16611",
      "academy-common-lib": "/academy-common-lib/static-1.13722",
      "dashboard-lib": "/dashboard-lib/static-1.81428",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8683",
      "line-items-api": "/line-items-api/static-1.655",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3800",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9017",
      "apps-service-types": "/apps-service-types/static-1.3856",
      "oauth-service-types": "/oauth-service-types/static-1.4229",
      "academy-service-client": "/academy-service-client/static-1.3662",
      "croppie": "/croppie/static-2.10",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7091",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.29131",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};